export enum AppPaths {
  AgenticAccess = "agentic-access",
  Bundles = "bundles",
  Config = "config",
  Dashboard = "dashboard",
  IamAssessment = "iam-assessments",
  Integrations = "integrations",
  IntegrationsSandbox = "sandbox/integrations",
  Inventory = "inventory",
  AccessManagement = "access-management",
  P0Admin = "p0-admin",
  Policies = "policies",
  Posture = "posture",
  Settings = "settings",
  Welcome = "welcome",
}
